<template>
  <ul
    class="navbar-nav"
    :class="classNames"
    @click="onClickNavbarItems"
    ref="navRoot"
  >
    <li class="nav-item">
      <router-link
        class="nav-link"
        :to="{ name: 'dashboard' }"
        :class="{
          'menu-link-active': $route.name.indexOf('dashboard') !== -1
        }"
        >Dashboard</router-link
      >
    </li>
    <li class="nav-item" v-if="can('sales.documents')">
      <router-link
        class="nav-link"
        :to="{ name: 'sales.documents' }"
        :class="{
          'menu-link-active': $route.name.indexOf('sales') !== -1
        }"
        >Ventas
      </router-link>
    </li>

    <!-- Catálogo dropdown: Directorio + Productos -->
    <li
      class="nav-item nav-item--dropdown"
      v-if="can('business.main') || can('catalogue.products')"
    >
      <button
        type="button"
        class="nav-link nav-link--dropdown"
        :class="{
          'menu-link-active': isCatalogoActive,
          'is-open': openDropdown === 'catalogo'
        }"
        @click.stop="toggleDropdown('catalogo')"
      >
        Catálogo
        <i class="el-icon-arrow-down nav-caret"></i>
      </button>
      <ul v-if="openDropdown === 'catalogo'" class="nav-dropdown-menu">
        <li v-if="can('business.main')">
          <router-link
            class="nav-dropdown-item"
            :to="{ name: 'business.main' }"
            :class="{
              'menu-link-active': $route.name.indexOf('business') !== -1
            }"
            @click.native="closeDropdowns"
            >Directorio</router-link
          >
        </li>
        <li v-if="can('catalogue.products')">
          <router-link
            class="nav-dropdown-item"
            :to="{ name: 'catalogue.products' }"
            :class="{
              'menu-link-active': $route.name.indexOf('catalogue') !== -1
            }"
            @click.native="closeDropdowns"
            >Productos</router-link
          >
        </li>
      </ul>
    </li>

    <!-- Gestión dropdown: Proyectos + Documentos -->
    <li
      class="nav-item nav-item--dropdown"
      v-if="can('projects') || can('documentos')"
    >
      <button
        type="button"
        class="nav-link nav-link--dropdown"
        :class="{
          'menu-link-active': isGestionActive,
          'is-open': openDropdown === 'gestion'
        }"
        @click.stop="toggleDropdown('gestion')"
      >
        Gestión
        <i class="el-icon-arrow-down nav-caret"></i>
      </button>
      <ul v-if="openDropdown === 'gestion'" class="nav-dropdown-menu">
        <li v-if="can('projects')">
          <router-link
            class="nav-dropdown-item"
            :class="{
              'menu-link-active': $route.name.indexOf('projects') !== -1,
              'nav-dropdown-item--locked': !hasProjectsModule
            }"
            :to="{ name: 'projects' }"
            @click.native="closeDropdowns"
          >
            Proyectos
            <svg
              v-if="!hasProjectsModule"
              class="nav-lock-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </router-link>
        </li>
        <li v-if="can('documentos')">
          <router-link
            class="nav-dropdown-item"
            :to="{ name: 'documentos' }"
            :class="{
              'menu-link-active': $route.name.indexOf('documentos') !== -1
            }"
            @click.native="closeDropdowns"
            >Documentos</router-link
          >
        </li>
      </ul>
    </li>

    <li class="nav-item" v-if="can('reports')">
      <router-link
        class="nav-link"
        :to="{ name: 'reports' }"
        :class="{
          'menu-link-active': $route.name.indexOf('reports') !== -1
        }"
        >Reportes</router-link
      >
    </li>
    <!--
      Marketing dropdown: Leads + Landings. Ambos módulos viven en mydessk-next
      (otro dominio: develop.crm.mydessk.com en dev, crm.mydessk.com en prod).
      El click pasa el token JWT vía URL hash (NO query string — el hash nunca
      llega al server, solo el browser lo lee). /auth/handoff de Next.js lo guarda
      en cookie y redirige al destino (next) autenticado.
    -->
    <li
      class="nav-item nav-item--dropdown"
      v-if="
        $store.getters.hasAnyPermission([
          'marketing.leads.view',
          'marketing.messaging.view',
          'marketing.flows.view',
          'marketing.mailing.view',
          'marketing.sites.view'
        ])
      "
    >
      <button
        type="button"
        class="nav-link nav-link--dropdown"
        :class="{ 'is-open': openDropdown === 'marketing' }"
        @click.stop="toggleDropdown('marketing')"
      >
        Marketing
        <span class="nav-leads-badge">BETA</span>
        <i class="el-icon-arrow-down nav-caret"></i>
      </button>
      <ul v-if="openDropdown === 'marketing'" class="nav-dropdown-menu">
        <!--
          Mismo orden que el sidebar del módulo Marketing (Next.js):
          Dashboard, Leads, Mensajería, Flujos, Mailing, Landings.
        -->
        <li v-permission="['marketing.leads.view', 'marketing.messaging.view']">
          <a
            class="nav-dropdown-item"
            :class="{ 'nav-dropdown-item--locked': !hasWhatsappAddon }"
            :href="leadsBaseUrl + '/dashboard'"
            @click.prevent="openMarketingDashboard"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="flex-shrink:0"
            >
              <rect x="3" y="3" width="7" height="9" rx="1"></rect>
              <rect x="14" y="3" width="7" height="5" rx="1"></rect>
              <rect x="14" y="12" width="7" height="9" rx="1"></rect>
              <rect x="3" y="16" width="7" height="5" rx="1"></rect>
            </svg>
            Dashboard
            <svg
              v-if="!hasWhatsappAddon"
              class="nav-lock-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </a>
        </li>
        <li v-permission="'marketing.leads.view'">
          <a
            class="nav-dropdown-item"
            :class="{ 'nav-dropdown-item--locked': !hasWhatsappAddon }"
            :href="leadsBaseUrl + '/leads'"
            @click.prevent="openLeads"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="flex-shrink:0"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            Leads
            <svg
              v-if="!hasWhatsappAddon"
              class="nav-lock-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </a>
        </li>
        <li v-permission="'marketing.messaging.view'">
          <a
            class="nav-dropdown-item nav-dropdown-item--mensajeria"
            :class="{ 'nav-dropdown-item--locked': !hasWhatsappAddon }"
            :href="leadsBaseUrl + '/mensajeria'"
            @click.prevent="openMensajeria"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="flex-shrink:0"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              />
            </svg>
            Mensajería
            <svg
              v-if="!hasWhatsappAddon"
              class="nav-lock-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </a>
        </li>
        <li v-permission="'marketing.flows.view'">
          <a
            class="nav-dropdown-item"
            :class="{ 'nav-dropdown-item--locked': !hasWhatsappAddon }"
            :href="leadsBaseUrl + '/flujos'"
            @click.prevent="openFlujos"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="flex-shrink:0"
            >
              <rect width="8" height="8" x="3" y="3" rx="2"></rect>
              <path d="M7 11v4a2 2 0 0 0 2 2h4"></path>
              <rect width="8" height="8" x="13" y="13" rx="2"></rect>
            </svg>
            Flujos
            <svg
              v-if="!hasWhatsappAddon"
              class="nav-lock-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </a>
        </li>
        <li v-permission="'marketing.mailing.view'">
          <a
            class="nav-dropdown-item"
            :class="{ 'nav-dropdown-item--locked': !hasWhatsappAddon }"
            :href="leadsBaseUrl + '/mailing'"
            @click.prevent="openMailing"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="flex-shrink:0"
            >
              <rect width="20" height="16" x="2" y="4" rx="2"></rect>
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
            </svg>
            Mailing
            <svg
              v-if="!hasWhatsappAddon"
              class="nav-lock-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </a>
        </li>
        <li v-permission="'marketing.sites.view'">
          <a
            class="nav-dropdown-item"
            :class="{ 'nav-dropdown-item--locked': !hasWhatsappAddon }"
            :href="leadsBaseUrl + '/sites'"
            @click.prevent="openLandings"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="flex-shrink:0"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M2 12h20"></path>
              <path
                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
              ></path>
            </svg>
            Landings
            <svg
              v-if="!hasWhatsappAddon"
              class="nav-lock-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import payService from "@/modules/dashboard/plans/services/payService";
import { permissionsForRoute } from "@/modules/dashboard/team/routePermissions";

export default {
  name: "NavbarItemsComponent",
  data() {
    return {
      openDropdown: null,
      hasWhatsappAddon: false
    };
  },
  computed: {
    hasProjectsModule() {
      return this.$store.getters.hasFeature("projects_module");
    },
    isCatalogoActive() {
      const n = this.$route.name || "";
      return n.indexOf("business") !== -1 || n.indexOf("catalogue") !== -1;
    },
    isGestionActive() {
      const n = this.$route.name || "";
      return n.indexOf("projects") !== -1 || n.indexOf("documentos") !== -1;
    },
    /**
     * URL base del módulo Next.js (Marketing/Leads — vive en mydessk-next).
     * Prioridad:
     *   1. VUE_APP_LEADS_URL si está definido (override manual desde Amplify env)
     *   2. Auto-detect según el host actual del frontend:
     *        develop.app.mydessk.com  → https://develop.marketing.mydessk.com
     *        app.mydessk.com          → https://marketing.mydessk.com
     *   3. /  (mismo dominio — fallback inocuo)
     *
     * Esto permite que el mismo build de Vue funcione en dev y prod sin tocar nada.
     */
    leadsBaseUrl() {
      if (process.env.VUE_APP_LEADS_URL) {
        // Si el usuario seteó VUE_APP_LEADS_URL=https://x/leads, sacamos /leads
        return process.env.VUE_APP_LEADS_URL.replace(/\/leads\/?$/, "");
      }
      // Auto-detect a partir del host actual: app.mydessk.com → marketing.mydessk.com
      if (
        typeof window !== "undefined" &&
        window.location &&
        window.location.host
      ) {
        const host = window.location.host;
        if (host.indexOf("app.mydessk.com") !== -1) {
          // develop.app.mydessk.com → develop.marketing.mydessk.com
          // app.mydessk.com         → marketing.mydessk.com
          return (
            "https://" +
            host.replace("app.mydessk.com", "marketing.mydessk.com")
          );
        }
      }
      return "";
    }
  },
  watch: {
    // Cierra dropdowns al cambiar de ruta
    $route() {
      this.closeDropdowns();
    }
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
    this.loadWhatsappAddonStatus();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    // Multi-usuario: muestra la sección solo si el rol tiene algún permiso
    // de la pantalla destino (mismo mapa que el guard del router).
    can(routeName) {
      const required = permissionsForRoute(routeName);
      return !required || this.$store.getters.hasAnyPermission(required);
    },
    onClickNavbarItems() {
      this.$emit("onClickNavbarItems");
    },
    async loadWhatsappAddonStatus() {
      try {
        const { data } = await payService.getWhatsappAddonStatus();
        this.hasWhatsappAddon = !!(
          data &&
          data.success &&
          data.data &&
          data.data.active
        );
      } catch (e) {
        // silencioso a propósito — sin esto el nav sigue mostrando el candado
      }
    },
    toggleDropdown(name) {
      this.openDropdown = this.openDropdown === name ? null : name;
    },
    closeDropdowns() {
      this.openDropdown = null;
    },
    handleOutsideClick(e) {
      if (this.openDropdown === null) return;
      const root = this.$refs.navRoot;
      if (root && !root.contains(e.target)) {
        this.closeDropdowns();
      }
    },
    /**
     * Abre el módulo Leads/Marketing pasando el token JWT vía URL hash.
     * Hash (#) NO se transmite al server, sólo el browser lo lee →
     * más seguro que query string para tokens.
     */
    /**
     * Abre el Dashboard de Marketing (primera pantalla del módulo), mismo handoff que Leads.
     */
    openMarketingDashboard() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token = user && user.token ? user.token : "";
      const base = this.leadsBaseUrl;
      if (!token) {
        window.location.href = base + "/dashboard";
        return;
      }
      window.location.href =
        base +
        "/auth/handoff#token=" +
        encodeURIComponent(token) +
        "&next=" +
        encodeURIComponent("/dashboard");
    },
    openLeads() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token = user && user.token ? user.token : "";
      const base = this.leadsBaseUrl;
      if (!token) {
        window.location.href = base + "/leads";
        return;
      }
      const url =
        base +
        "/auth/handoff#token=" +
        encodeURIComponent(token) +
        "&next=" +
        encodeURIComponent("/leads");
      window.location.href = url;
    },
    /**
     * Abre el módulo Landings (Sites) en mydessk-next, mismo handoff que Leads.
     */
    openLandings() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token = user && user.token ? user.token : "";
      const base = this.leadsBaseUrl;
      if (!token) {
        window.location.href = base + "/sites";
        return;
      }
      const url =
        base +
        "/auth/handoff#token=" +
        encodeURIComponent(token) +
        "&next=" +
        encodeURIComponent("/sites");
      window.location.href = url;
    },
    openMensajeria() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token = user && user.token ? user.token : "";
      const base = this.leadsBaseUrl;
      if (!token) {
        window.location.href = base + "/mensajeria";
        return;
      }
      const url =
        base +
        "/auth/handoff#token=" +
        encodeURIComponent(token) +
        "&next=" +
        encodeURIComponent("/mensajeria");
      window.location.href = url;
    },
    /**
     * Abre el módulo Flujos en mydessk-next, mismo handoff que Leads.
     */
    openFlujos() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token = user && user.token ? user.token : "";
      const base = this.leadsBaseUrl;
      if (!token) {
        window.location.href = base + "/flujos";
        return;
      }
      const url =
        base +
        "/auth/handoff#token=" +
        encodeURIComponent(token) +
        "&next=" +
        encodeURIComponent("/flujos");
      window.location.href = url;
    },
    /**
     * Abre el módulo Mailing en mydessk-next, mismo handoff que Leads.
     */
    openMailing() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token = user && user.token ? user.token : "";
      const base = this.leadsBaseUrl;
      if (!token) {
        window.location.href = base + "/mailing";
        return;
      }
      const url =
        base +
        "/auth/handoff#token=" +
        encodeURIComponent(token) +
        "&next=" +
        encodeURIComponent("/mailing");
      window.location.href = url;
    },
    openFirmadoMasivo() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token = user && user.token ? user.token : "";
      const businessId =
        this.$store.getters.businessId ||
        this.$store.state.businessStore?.selectedBusiness?.id ||
        "";
      const next =
        "/firmado-masivo" + (businessId ? "?business_id=" + businessId : "");
      const base = this.leadsBaseUrl;
      if (!token) {
        window.location.href = base + next;
        return;
      }
      const url =
        base +
        "/auth/handoff#token=" +
        encodeURIComponent(token) +
        "&next=" +
        encodeURIComponent(next);
      window.location.href = url;
    }
  },
  props: {
    classNames: {
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar-light .navbar-nav .nav-link {
  font-weight: bolder !important;
}
.nav-item {
  margin-right: 1rem;
  font-size: 14px;
}
.mobile li a {
  color: #fff !important;
  text-align: center;
  font-size: 1.3rem;
  margin-top: 0.8rem;
}
.nav-link--locked {
  opacity: 0.55;
}
.nav-lock-icon {
  display: inline-block;
  margin-left: 3px;
  vertical-align: middle;
  position: relative;
  top: -1px;
}
.nav-link--leads {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.nav-leads-badge {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #fef3e0;
  color: #ba7517;
  line-height: 1;
}

/* ── Dropdown ─────────────────────────────────────────── */
.nav-item--dropdown {
  position: relative;
}
.nav-link--dropdown {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #2d2b55; // mismo $--color-primary que los <a> hermanos
  font: inherit;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: bolder;
  &:hover,
  &:focus {
    outline: none;
    color: #3fdbbf;
  }
  &.menu-link-active,
  &.is-open {
    color: #3fdbbf;
  }
}
.nav-caret {
  font-size: 11px;
  transition: transform 0.15s;
  .is-open & {
    transform: rotate(180deg);
  }
}
.nav-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 200px;
  background: #fff;
  border: 1px solid #e4eaf6;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(45, 43, 85, 0.12);
  list-style: none;
  padding: 6px;
  margin: 0;
  z-index: 1100;
}
.nav-dropdown-menu li {
  list-style: none;
}
.nav-dropdown-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #31355c;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.12s, color 0.12s;
  &:hover {
    background: #f0fdf9;
    color: #3fdbbf;
    text-decoration: none;
  }
  &.menu-link-active {
    background: #f0fdf9;
    color: #3fdbbf;
  }
}
.nav-dropdown-item--locked {
  opacity: 0.55;
}

/* ── Modo móvil (drawer) ─────────────────────────────── */
.mobile-clean .nav-item--dropdown {
  position: static;
}
.mobile-clean .nav-link--dropdown {
  width: 100%;
  justify-content: center;
  padding: 14px 24px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #606266 !important;
  text-align: center;
  &:hover {
    background: #f7f8f9;
    color: #31355c !important;
  }
}
.mobile-clean .nav-dropdown-menu {
  position: static;
  box-shadow: none;
  border: none;
  border-radius: 0;
  padding: 0;
  background: #fafbfd;
}
.mobile-clean .nav-dropdown-item {
  justify-content: center;
  padding: 12px 24px;
  border-radius: 0;
  font-weight: 500;
  font-size: 14px;
  color: #606266;
  &:hover,
  &.menu-link-active {
    background: #f0fdf9;
    color: #3fdbbf;
  }
}
</style>
